<template>
  <base-material-card
    icon="mdi-alarm-light"
    color="primary"
    inline
    v-if="inspectionProfile && inspectionProfile.resume"
    class="mt-12 px-5 py-5 mb-10"
  >
    <template v-slot:after-heading>
      <div class="title font-weight-bold overflow-ellipsis">
        {{ $t("inspectionProfile.inspectionSummary") }}
      </div>
    </template>

    <v-card-text>
      <v-row>
        <v-col md="6" cols="12"
          ><v-chip label="" class="ma-2" color="secondary">Tag </v-chip>
          {{ inspectionProfile.equipmentProfile.equipTag }}</v-col
        >
        <v-col md="6" cols="12">
          <v-chip label class="ma-2" color="secondary">
            {{ $t("inspectionProfile.createdBy") }}
          </v-chip>
          {{ inspectionProfile.createdBy }}</v-col
        >
        <v-col md="6" cols="12">
          <v-chip label class="ma-2 " color="secondary">
            {{ $t("inspectionProfile.PerfomedBy") }}
          </v-chip>
          {{ inspectionProfile.performedBy }}</v-col
        >
        <v-col md="6" cols="12">
          <v-chip label class="ma-2" color="secondary">
            {{ $t("inspectionProfile.generalStatus") }}
          </v-chip>
          {{ resume.status.name }} Zone</v-col
        >
      </v-row>
    </v-card-text>
    <v-expansion-panels>
      <v-expansion-panel v-if="resume && resume.alarmZone.count > 0">
        <v-expansion-panel-header class="white--text" color="#B81D13">
          {{ $t("inspectionProfile.alarmZone") }}:
          {{ resume.alarmZone.count }} Variables
        </v-expansion-panel-header>
        <v-expansion-panel-content class="my-4">
          <v-list dense>
            <v-list-item-group>
              <template v-for="(item, index) in resume.alarmZone.codes">
                <v-list-item :key="index">
                  <v-list-item-content>
                    <v-list-item-title
                      ><v-chip color="primary" label="" x-small="">{{
                        $t(`groups.${item.groups}`)
                      }}</v-chip>
                      {{
                        variablesTags.has(item.code)
                          ? `${variablesTags.get(item.code)} - ${$t(
                              `variables.${item.code}`
                            )}`
                          : $t(`variables.${item.code}`)
                      }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="text--primary"
                      v-text="
                        item.type === 'deathLine'
                          ? timeAgo(item.value)
                          : parseFloat(readValue(item)).toFixed(2) +
                            ' ' +
                            unit(item.type)
                      "
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider
                  v-if="index + 1 < resume.alarmZone.codes.length"
                  :key="index"
                ></v-divider>
              </template> </v-list-item-group
          ></v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="resume && resume.warningZone.count > 0">
        <v-expansion-panel-header class="white--text" color="#EFB700">
          {{ $t("inspectionProfile.warningZone") }}:
          {{ resume.warningZone.count }} Variables</v-expansion-panel-header
        >
        <v-expansion-panel-content class="my-4">
          <v-list dense>
            <v-list-item-group>
              <template v-for="(item, index) in resume.warningZone.codes">
                <v-list-item :key="index">
                  <v-list-item-content>
                    <v-list-item-title
                      ><v-chip color="primary" label="" x-small="">{{
                        $t(`groups.${item.groups}`)
                      }}</v-chip>
                      {{
                        variablesTags.has(item.code)
                          ? `${variablesTags.get(item.code)} - ${$t(
                              `variables.${item.code}`
                            )}`
                          : $t(`variables.${item.code}`)
                      }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="text--primary"
                      v-text="
                        item.type === 'deathLine'
                          ? timeAgo(item.value)
                          : parseFloat(readValue(item)).toFixed(2) +
                            ' ' +
                            unit(item.type)
                      "
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider
                  v-if="index + 1 < resume.warningZone.codes.length"
                  :key="index"
                ></v-divider>
              </template> </v-list-item-group
          ></v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="resume && resume.smoothZone.count > 0">
        <v-expansion-panel-header class="white--text" color="#008450">
          {{ $t("inspectionProfile.smoothZone") }}:
          {{ resume.smoothZone.count }} Variables</v-expansion-panel-header
        >
        <v-expansion-panel-content class="my-4">
          <v-list dense>
            <v-list-item-group>
              <template v-for="(item, index) in resume.smoothZone.codes">
                <v-list-item :key="index">
                  <v-list-item-content>
                    <v-list-item-title
                      ><v-chip color="primary" label="" x-small="">{{
                        $t(`groups.${item.groups}`)
                      }}</v-chip>
                      {{
                        variablesTags.has(item.code)
                          ? `${variablesTags.get(item.code)} - ${$t(
                              `variables.${item.code}`
                            )}`
                          : $t(`variables.${item.code}`)
                      }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="text--primary"
                      v-text="
                        item.type === 'deathLine'
                          ? timeAgo(item.value)
                          : parseFloat(readValue(item)).toFixed(2) +
                            ' ' +
                            unit(item.type)
                      "
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider
                  v-if="index + 1 < resume.smoothZone.codes.length"
                  :key="`divider-${index}`"
                ></v-divider>
              </template> </v-list-item-group
          ></v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </base-material-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { unitDefault } from "@/settings/unitTypes";
import readValues from "@/mixins/readValues";
export default {
  name: "resume",
  props: ["variablesTags"],
  mixins: [readValues],
  computed: {
    ...mapGetters("auth", ["isMetric", "isMetax", "adminAndUp"]),
    ...mapState("inspections", ["inspectionProfile"]),
    ...mapState("auth", ["user"]),
    resume() {
      return this.inspectionProfile?.resume
        ? this.inspectionProfile?.resume
        : null;
    }
  },
  methods: {
    timeAgo(date) {
      const time = new Date() - new Date(date);
      const timeObject = [
        ["year", 31536000],
        ["month", 2592000],
        ["day", 86400],
        ["minute", 60],
        ["second", 1]
      ];

      const lang = this.user.language ? this.user.language : "en";
      const rtf = new Intl.RelativeTimeFormat(lang);

      const seconds = time / 1000;
      let timeago;

      for (const [unit, value] of timeObject) {
        if (seconds > value || unit === "seconds") {
          timeago = -Math.floor(parseFloat(seconds / +value));
          return `${rtf.format(timeago, unit)}`;
        }
      }
    },
    readValue(variable) {
      if (this.isMetric) {
        return parseFloat(variable?.value);
      } else {
        let unit = this.unit(variable?.type);
        return parseFloat(
          this.transformUnit(variable?.value, variable?.type, unit)
        );
      }
    },
    unit(item) {
      // Selecciona el Unit por defecto segun el perfil del usuario
      return this.isMetric
        ? unitDefault[item].metric
        : unitDefault[item].imperial;
    }
  }
};
</script>
